import { writable } from "svelte/store";

export const forceShowProjectsMarketingModalStore = writable(null);
